import { IPSDFilter, IPSDFilterList, IPSDTop } from '../types/psd.types';
import { api } from './api';

const baseUrl = '/public/psd';

export const getAllPsdData = (kato: number, years: string[]) => {
    return api.get(`${baseUrl}/all?kato=${kato}${years.map(year => `&years=${year}`).join('')}`).then(res => res.data.data)
}

export const getTopPsdData = (kato: number, body: IPSDFilter): Promise<IPSDTop> => {
    return api.post(`${baseUrl}/top?kato=${kato}`, body).then(res => res.data.data)
}

export const getPsdFilters = (kato: number, body: IPSDFilter): Promise<IPSDFilterList> => {
    return api.post(`${baseUrl}/top/filter?kato=${kato}`, body).then(res => res.data.data)
}